import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { TFunction, i18n } from 'i18next';

import { AddinRouter } from './AddinRouter';
import { GeApi, GlobalServiceInterface } from '../ts/Ge';
import { OutlookActions, DefaultLogger, DialogResult, Container } from '../ts/infrastructure';
import { GlobalServiceContext } from './helpers/GlobalContexts';
import { Palettes } from './helpers/Palette';
import { AppointmentOutlookActions } from "../ts/infrastructure/AppointmentOutlookActions";
import { apm, ApmBase } from '@elastic/apm-rum';

interface State {
  selectedPolicyIndex: string | number,
  showEngPanel: boolean,
  showServerAccessError: boolean,
  iframeSrc: string,
  iframeCb: (result: DialogResult) => null
}

interface Props {
  t: TFunction
  tReady: boolean
  i18n: i18n
  container: Container
  apm: ApmBase
}

const NO_SECURE_POLICY_ID = -1;

class App extends Component<Props, State> {
  protected globalService: GlobalServiceInterface;

  state: State = {
    selectedPolicyIndex: NO_SECURE_POLICY_ID,
    showEngPanel: false,
    showServerAccessError: false,
    iframeSrc: null,
    iframeCb: null
  };

  constructor(props: Props) {
    super(props);
    const logger = new DefaultLogger();
    const itemType = Office.context.mailbox?.item?.itemType;
    const outlookActions = itemType === Office.MailboxEnums.ItemType.Message ? new OutlookActions(logger, apm) : new AppointmentOutlookActions(logger, apm);
    const inMailboxContext = outlookActions.init();

    this.globalService = {
      logger,
      outlookActions,
      geApi: null,
      t: this.props.t,
      apm: this.props.apm
    };

    // The only way to recreate the "same" instance of GeApi.
    const storedState = JSON.parse(localStorage.getItem("GeApiState"));
    this.globalService.geApi = new GeApi(this.globalService, this.props.container, itemType  as Office.MailboxEnums.ItemType);
    if (storedState) this.globalService.geApi.setState(storedState);


    if (inMailboxContext) {
      this.globalService.outlookActions.setMessageChangeCallback(() => {
        // this.globalService.policies.loadPolicies(CacheHandler.CachePolicy.USE_CACHE);
      });
    }

    Palettes.restoreSelectedPalette();
  }

  private setIframeSrc = (iframeSrc: string, iframeCb: (result: DialogResult) => null) => {
    this.setState({ iframeSrc, iframeCb });
  }

  /**
   * This function run every time React decides to render the component.
   */
  public render() {
    const { iframeSrc, iframeCb } = this.state;

    return (
      <GlobalServiceContext globalService={this.globalService}
        iframeContext={iframeSrc}
        iframeDialogSetter={this.setIframeSrc}
        iframeDialogHandler={iframeCb}
      >
        <AddinRouter />
      </GlobalServiceContext>
    );
  }
}
export default withTranslation()(App);